import { z } from 'zod';

import {
    createDeleteSchema,
    createUpdateSchemaFromAdd,
    optionalBoolean,
    optionalString,
    optionalUuid,
    requiredNumber,
    requiredString,
    requiredUuid,
} from './fields';
import { SYNC_UPDATE_VALIDATION_SCHEMA } from './common';

export const createContactsAddSchema = () =>
    z.object({
        id: requiredUuid(),
        first_name: requiredString(),
        last_name: optionalString(),
        description: optionalString(),
        role: optionalString(),
        phone: optionalString(),
        phone_prefix: optionalString(),
        opt_in_status: optionalString(),
        email: optionalString(),
        business_name: optionalString(),
        address: optionalString(),
        comments: optionalString(),
        location_id: optionalUuid(),
        user_id: requiredUuid(),
        organisation_id: requiredUuid(),
        billable: optionalBoolean(),
        hidden: optionalBoolean(),
        synced: optionalBoolean(),
        created_at: requiredNumber(),
        updated_at: requiredNumber(),
    });

export const createContactsUpdateSchema = () =>
    createUpdateSchemaFromAdd(
        createContactsAddSchema(),
        SYNC_UPDATE_VALIDATION_SCHEMA.contacts,
    );

export const createContactsDeleteSchema = () => createDeleteSchema();

export const createContactsSchemas = () => ({
    add: createContactsAddSchema(),
    update: createContactsUpdateSchema(),
    delete: createContactsDeleteSchema(),
});
